import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (ticket) =>
  f3tch('/crm/tickets/').profile(profile()).body(ticket).post();
